import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../browser-manager-data/local-storage.service';
import {
  FeedbackScreenEnum,
  getHideFeedbackCardKey,
} from './feedback-data.data';
import { FeedbackDataDispatcher } from './feedback-data.dispatcher';
import {
  getFeedbackHiddenForFeatureNameForAccount,
  getScreenById,
} from './feedback-data.reducer';
import { DateTimeService } from 'i2g-ng-utils';

@Injectable()
export class FeedbackDataStore {
  constructor(
    private _localStorageService: LocalStorageService,
    private _feedbackDataDispatcher: FeedbackDataDispatcher,
    private _dateTimeService: DateTimeService,
    private _store: Store<any>
  ) {}

  getFeedbackHiddenForFeatureNameForAccount(
    featureName: string,
    accountId: string
  ): Observable<boolean> {
    const feedbackCardHiddenTime: string = this._localStorageService.getItem(
      getHideFeedbackCardKey(featureName, accountId)
    );

    // check if it has been 30 days
    if (
      feedbackCardHiddenTime &&
      this._dateTimeService.isValidDate(feedbackCardHiddenTime, 'X') &&
      this._dateTimeService.isBefore(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        Number(this._dateTimeService.getNow('X')),
        Number(feedbackCardHiddenTime)
      )
    ) {
      this._feedbackDataDispatcher.hideFeedbackCardForAccount(
        featureName,
        accountId
      );
    } else {
      this._localStorageService.removeItem(
        getHideFeedbackCardKey(featureName, accountId)
      );
    }

    return this._store.select(
      getFeedbackHiddenForFeatureNameForAccount(featureName, accountId)
    );
  }

  getScreenById(screenId: FeedbackScreenEnum): Observable<any> {
    return this._store.select(getScreenById(screenId));
  }
}
